/**
 * Deep merge plain objects. Later arguments override; arrays are replaced (not merged).
 * Used to layer partial locale files on top of a full dictionary.
 * Target is deep-cloned so shared imports (e.g. en base) are never mutated.
 */
function clonePlain(value) {
  if (value == null || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(clonePlain);
  const out = {};
  for (const k of Object.keys(value)) {
    out[k] = clonePlain(value[k]);
  }
  return out;
}

export function deepMerge(target, ...sources) {
  const out = clonePlain(target || {});
  for (const src of sources) {
    if (!src || typeof src !== 'object') continue;
    for (const k of Object.keys(src)) {
      const v = src[k];
      const o = out[k];
      if (v && typeof v === 'object' && !Array.isArray(v) && o && typeof o === 'object' && !Array.isArray(o)) {
        out[k] = deepMerge(o, v);
      } else {
        out[k] = v;
      }
    }
  }
  return out;
}
